// Browser stub for @opentelemetry/sdk-metrics
// The frontend only sends traces, not metrics.
// sdk-metrics is a transitive dep of otlp-transformer but never used in browser context.
module.exports = {};
